function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  fill: "#fff",
  d: "M0 219.6L73 93.7l44.7 26L187.7 0l15.6 9.3v210.3z"
});

function SvgMountain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.3 219.6"
  }, props), _ref);
}

export default SvgMountain;